import { render } from "./ReportCheckBoxFilter.vue?vue&type=template&id=21486df3&ts=true"
import script from "./ReportCheckBoxFilter.vue?vue&type=script&lang=ts"
export * from "./ReportCheckBoxFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__